// Client "Occupation or upcoming event" — closed enum.
// MUST stay in sync with backend/context_profiles.py::CONTEXTS.
// Feb 2026 (iter 229 — split into OCCUPATIONS + EVENTS with tile icons).
//
// `group` steers the intake picker into two visual sections
// ("Occupation" vs "Event / Moment"). `icon` is a lucide-react
// component name string — the intake modal maps that string to a
// component via the ICONS map below so we can render tile-images
// without pulling every icon into every consumer.

export const CLIENT_CONTEXTS = [
  // ─── Occupations ────────────────────────────────────────────────
  { value: 'business_law',        label: 'Business — Law',            group: 'occupation', icon: 'Scale' },
  { value: 'business_finance',    label: 'Business — Finance',        group: 'occupation', icon: 'TrendingUp' },
  { value: 'business_tech',       label: 'Business — Tech / Startup', group: 'occupation', icon: 'Cpu' },
  { value: 'business_consulting', label: 'Business — Consulting',     group: 'occupation', icon: 'Briefcase' },
  { value: 'creative_media',      label: 'Creative / Media',          group: 'occupation', icon: 'Camera' },
  { value: 'medicine',            label: 'Medicine',                  group: 'occupation', icon: 'Stethoscope' },
  { value: 'entertainment',       label: 'Entertainment / Performer', group: 'occupation', icon: 'Mic' },
  { value: 'real_estate_sales',   label: 'Real Estate / Sales',       group: 'occupation', icon: 'Home' },
  { value: 'government',          label: 'Government / Public',       group: 'occupation', icon: 'Landmark' },

  // ─── Events & moments ───────────────────────────────────────────
  { value: 'wedding_groom',       label: 'Wedding — Groom',           group: 'event',      icon: 'Heart' },
  { value: 'wedding_groomsman',   label: 'Wedding — Groomsman',       group: 'event',      icon: 'Users' },
  { value: 'wedding_guest',       label: 'Wedding — Guest',           group: 'event',      icon: 'PartyPopper' },
  { value: 'black_tie_gala',      label: 'Black-Tie / Gala',          group: 'event',      icon: 'Gem' },
  { value: 'cocktail_charity',    label: 'Cocktail / Charity',        group: 'event',      icon: 'Wine' },
  { value: 'everyday_casual',     label: 'Everyday / Smart Casual',   group: 'event',      icon: 'Sun' },
  { value: 'vacation_resort',     label: 'Vacation / Resort',         group: 'event',      icon: 'Plane' },
  { value: 'interview',           label: 'Interview / Job-Hunt',      group: 'event',      icon: 'Search' },
];

export const OCCUPATION_CONTEXTS = CLIENT_CONTEXTS.filter(c => c.group === 'occupation');
export const EVENT_CONTEXTS = CLIENT_CONTEXTS.filter(c => c.group === 'event');

const _MAP = Object.fromEntries(CLIENT_CONTEXTS.map(c => [c.value, c.label]));

export function contextLabel(value) {
  return _MAP[value] || null;
}

export function isValidContext(value) {
  return typeof value === 'string' && value in _MAP;
}
